export default __webpack_public_path__ + "static/media/Aloe-Vera-Tea-Tree-Bottle.296698f4.png";